<template>
  <div class="modal" id="modal-search-product-units" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Search <template v-if="hasBarcoding">Product Units</template><template v-else>by SKUs</template></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="processUnitsSearch">
          <div class="modal-body">

            <div class="form-group row">
              <label class="col-sm-3 col-form-label required" for="input-search-quantity">Quantity</label>
              <div class="col-sm-9">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <button type="button" class="btn btn-outline-secondary" @click.prevent="decreaseQuantity">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <input type="number" class="form-control text-center" id="input-search-quantity" name="quantity" min="1" v-model="quantity" required>
                  <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary" @click.prevent="increaseQuantity">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-0">
              <label class="col-sm-3 col-form-label required" for="input-search-barcode">
                <template v-if="hasBarcoding">Barcode</template>
                <template v-else>SKU</template>
              </label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="input-search-barcode" name="barcode" v-model="barcode" required>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-secondary">Close</button>
            <button type="submit" class="btn btn-primary" :disabled="!barcode || processing">
              <i v-if="processing" class="fas fa-circle-notch fa-spin"></i>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  name: 'SearchProductUnits',
  data () {
    return {
      processing: false,
      quantity: 1,
      barcode: null
    }
  },
  computed: {
    hasBarcoding () {
      return this.$store.state.store ? this.$store.state.store.settings.inventory.barcoding : false
    }
  },
  mounted () {
    jQuery('#modal-search-product-units').on('shown.bs.modal', function () {
      jQuery('#input-search-quantity').val(1)
      jQuery('#input-search-barcode').val('').focus()
    })
  },
  methods: {
    decreaseQuantity: function () {
      if (this.quantity > 1) {
        this.quantity--
      }
    },

    increaseQuantity: function () {
      this.quantity++
    },

    async processUnitsSearch () {
      if (!this.barcode) {
        this.$toast.error('Please provide the barcode')
        return
      }

      this.processing = true

      await this.$parent.$parent._addToCart(0, 0, 0, this.quantity, this.barcode)
        .then(() => {
          this.quantity = 1
          this.barcode = null
          jQuery('#modal-search-product-units').modal('hide')
        })
        .catch((error) => {
          this.$toast.error(error)
        })
        .finally(() => {
          this.processing = false
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sale/partials/SearchProductUnits.vue